//@flow

import * as React from 'react';
import styled from 'styled-components';

type Props = {
  left?: string,
  right?: string,
  top?: string,
  bottom?: string,
};

const StyledButton = styled.div`
  left: ${props => props.left};
  right: ${props => props.right};
  top: ${props => props.top};
  bottom: ${props => props.bottom};    
  overflow: hidden;
  user-select: none;
  vertical-align: middle;
  z-index: 0;
  transition: background-color 0.1s ease-in-out;
  border: 2px solid;
  border-color: ${props => props.disabled ? '#637fa3' : '#265a9c'};
  color: ${props => props.disabled ? '#637fa3' : '#265a9c'};
  border-radius: 4px;
  padding: 0 4px;
  box-shadow: ${props => props.active
    ? 'inset 0 1px 3px rgba(0,0,0,0.12), inset 0 1px 2px rgba(0,0,0,0.24)'
    : '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'};   
  align-items: center;
  justify-content: center;
  cursor: pointer;   

  :hover{
    background-color: #f3f3f3;    
    box-shadow: ${props => props.active
    ? 'inset 0 2px 4px rgba(0,0,0,0.16), inset 0 2px 4px rgba(0,0,0,0.23)'
    : '0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23)'};   
  }

  /* not visible */
  display: ${props => props.visible === false ? 'none' : 'flex'};

   /* disabled */
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};   
  cursor: ${props => props.disabled ? 'default' : 'pointer'};   
  background-color: ${props => props.disabled
    ? '#e3e3e360'
    : props.active
      ? '#f1f1f1'
      : 'rgba(0, 0, 0, 0)'
  };
`;


const GhostButton = (props: Props) => (
  <StyledButton
    tabIndex='0'
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        props.onClick();
      }
    }}
    {
    ...props
    } />
);

export default GhostButton;


// WEBPACK FOOTER //
// ./src/components/GhostButton.jsx